import { useEffect, useRef } from 'react'

const useResizeObserver = (element, onResize) => {
  const handleResize = entries => {
    if (Array.isArray(entries) && entries.length > 0) {
      const { width, height } = entries[0].contentRect

      typeof onResize === 'function' && onResize({ width, height })
    }
  }
  const { current: observer } = useRef(new ResizeObserver(handleResize))

  useEffect(() => {
    element && observer.observe(element)

    return () => {
      element && observer.unobserve(element)
    }
  }, [element])

  useEffect(() => {
    return () => {
      observer.disconnect()
    }
  }, [])
}

export default useResizeObserver
